import React from 'react';
import './card.style.css'

export const Card = (props)=>{

    //{`https://robohash.org/${props.monster.id}?set=set1&size=180x180`}

    return (
        <div className="card-container">
            <img src={props.monster.image} alt="monster" />
            <h2>{props.monster.name}</h2>
            <p>{props.monster.email}</p>
        </div>
    );

};